export default function gtmEvent(eventName, payload) {
  if (process.env.NODE_ENV === 'development') {
    console.log('Custom GTM Event', eventName, payload);
  }

  if (typeof window.dataLayer !== 'undefined' && typeof window.dataLayer.push === 'function') {
    window.dataLayer.push({ event: eventName, ...(payload || {}) });
  }
}
